export const LinkType = Object.freeze({
  GROUP: 'group',
  CLIENT: 'client',
  LOCATION: 'location',
})
